var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4431",
    "data-name": "Group 4431",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.06,
    height: 5.594,
    viewBox: "0 0 8.06 5.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-keyboard-arrow-right",
    "data-name": "Icon material-keyboard-arrow-right",
    d: "M0,7.113,3.458,4.03,0,.947,1.064,0l4.53,4.03L1.064,8.06Z",
    transform: "translate(0 5.594) rotate(-90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.bdb69dc86d1f6f54c1c10dbc342a149c.svg";
export { ForwardRef as ReactComponent };